<template>
  <div style="background-color: #FFFFFF;">
    <div style="position: relative;">
      <canvas class="progress_box2" :height='height - 33' :width='width - 2' :id="'ccc'+can_id"></canvas>
      <img class="progress_box" :height='height' :width='width' src="@/assets/img/fodder.png" />
      <div class="progress_box3" :style='{top: (height/2 - 33) + "px"}'>{{ parseInt((stableValue / 1000) * 10) / 10 }} T</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 64
    },
    height: {
      type: Number,
      default: 80
    },
    percent: {
      type: Number,
      default: 0
    },
    stableValue: {
      type: Number,
      default: 0
    },
    store: {
      type: String,
      default: '--'
    },
    can_id: {
      type: String,
      default: 'ccc'
    }
  },
  data(){
    return{
    }
  },
  mounted: function() {
    this.drawBg(this.percent>100?100:this.percent);
  },
  methods: {
    drawBg: function(percent) {
      let canvas = document.getElementById('ccc' + this.can_id);
      let ctx = canvas.getContext('2d');
      let height = this.height - 33;
      // let timer = setTimeout(() => {
      let fillHeight = ((height * percent) / 100).toFixed(0);

      ctx.clearRect(0, 0, this.width, height);

      ctx.beginPath();
      ctx.moveTo(0, height - fillHeight);
      ctx.lineTo(this.width, height - fillHeight);
      ctx.lineTo(this.width, height);
      ctx.lineTo(0, height);
      ctx.fillStyle = "#FF9912";
      ctx.fill();

      ctx.fillStyle = "#000";
      let size = ((height / 256) * 32).toFixed(0);
      ctx.font = size + "px sans-serif";
      ctx.fillText(
        this.store,
        (this.width - this.store.length * size / 2) / 2,
        (height * 2) / 5
      );

    }
  }
};
</script>

<style>
.progress_box {
  position: absolute;
  top: 0;
  left: 0;
}
.progress_box2 {
  position: absolute;
  top: 7px;
  left: 1px;
}
.progress_box3 {
  position: absolute;
  text-align: center;
  width: 100%;
  font-weight: bold;
}

</style>

